import { Grid } from '@mui/material';

import { Typography } from '@uhc-tempo/components';

/**
 * a component to render provider information as a popup on the map view
 * @param {Object} props - provider information
 * @returns
 */
const LocationPopUp = ({ providerName, specialties, phoneNum }) => {
    return (
        <Grid container direction="column">
            <Typography.H6
                style={{
                    color: '#196ECF',
                    fontSize: '20.25px',
                    fontWeight: '500',
                    marginBottom: '0px',
                }}
                data-testid="providerNameLocationPopup"
            >
                {providerName}
            </Typography.H6>
            <Typography.H6
                style={{
                    color: '#333333',
                    fontSize: '15px',
                    fontWeight: '400',
                    marginBottom: '0px',
                }}
                data-testid="providerSpecialtiesLocationPopup"
            >
                {specialties}
            </Typography.H6>
            <Grid container direction="row" alignItems="center">
                <Typography.H6
                    style={{
                        color: '#196ECF',
                        fontSize: '15px',
                        fontWeight: '500',
                        marginBottom: '0px',
                    }}
                    data-testid="providerPhoneNumberLocationPopup"
                >
                    {phoneNum}
                </Typography.H6>
                <Typography.Footnote
                    style={{
                        color: '#5A5A5A',
                        fontSize: '11.25px',
                        fontWeight: '400',
                        marginBottom: '0px',
                        paddingLeft: '6px',
                    }}
                    data-testid="providerPhoneLabelLocationPopup"
                >
                    Phone
                </Typography.Footnote>
            </Grid>
            <Grid container direction="row" alignItems="center">
                <Typography.H6
                    style={{
                        color: '#196ECF',
                        fontSize: '15px',
                        fontWeight: '500',
                        marginBottom: '0px',
                    }}
                    data-testid="providerTTYNumberLocationPopup"
                >
                    711
                </Typography.H6>
                <Typography.Footnote
                    style={{
                        color: '#5A5A5A',
                        fontSize: '11.25px',
                        fontWeight: '400',
                        marginBottom: '0px',
                        paddingLeft: '6px',
                    }}
                    data-testid="providerTTYLabelLocationPopup"
                >
                    TTY
                </Typography.Footnote>
            </Grid>
        </Grid>
    );
};
export default LocationPopUp;
